
export function base64UrlEncode(input: string) {
  const base64 = btoa(input); 
  return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, ''); 
}

export function base64UrlDecode(input: string) {
  const base64 = input.replace(/-/g, '+').replace(/_/g, '/'); 
  return atob(base64); 
}
